import { Button } from 'components/ui';
import AuthErrorPanel from 'pages/Auth/components/AuthErrorPanel';
import SignOutButton from 'pages/Auth/components/SignOutButton';
import { ContactAdminRoot } from './ContactAdminOrInquireLicensing.styles';

const ContactAdminOrInquireLicensing = () => (
  <ContactAdminRoot>
    <AuthErrorPanel
      description="Contact your account manager at Scalar if you need access, or inquire about licensing."
      extraAction={<SignOutButton />}
      mainAction={(
        <Button<'a'>
          component="a"
          href="https://scalar.io/product"
          rel="noopener noreferrer"
          target="_blank"
          variant="outlined"
          visualVariant="primaryOutline"
        >
          Inquire about licensing
        </Button>
      )}
      title="You do not have access to any Scalar valuation products."
    />
  </ContactAdminRoot>
);

export default ContactAdminOrInquireLicensing;
